import { ReportGridColDef } from "./subComponents/reportTable";

export const columnsConfig: {
    dailySalesReport: ReportGridColDef[], categorySalesReport: ReportGridColDef[],
    detailedSalesReport: ReportGridColDef[], itemSalesReport: ReportGridColDef[],
    purchasePaymentReport: ReportGridColDef[],PurchaseGstReport:ReportGridColDef[],
    CategoryExpenseReport: ReportGridColDef[],ProfitExpenseReport: ReportGridColDef[],
    purchaseReport: ReportGridColDef[],
} = {
    dailySalesReport: [
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },

        { field: "totalBills", headerName: "Total Bills", flex: 1, type: "number" },

        {
            field: "totalSales",
            headerName: "Total Sales",
            flex: 1,
            type: "number",
            reportType: "currency"
        },

        { field: "cash", headerName: "CASH", flex: 1, type: "number", reportType: "currency" },
        { field: "upi", headerName: "UPI", flex: 1, type: "number", reportType: "currency" },
        { field: "card", headerName: "CARD", flex: 1, type: "number", reportType: "currency" },
        { field: "bank", headerName: "BANK", flex: 1, type: "number", reportType: "currency" },
    ],

    detailedSalesReport: [
        {
            field: "invoiceNo",
            headerName: "Invoice #",
            flex: 1
        },

        {
            field: "date",
            headerName: "Date",
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null,
            flex: 1
        },

        {
            field: "customerName",
            headerName: "Customer",
            flex: 1.5
        },

        {
            field: "productName",
            headerName: "Product",
            flex: 2
        },

        {
            field: "quantity",
            headerName: "Qty",
            type: "number",
            flex: 0.7
        },

        {
            field: "pricePerUnit",
            headerName: "Price",
            type: "number",
            reportType: "currency",
            flex: 1
        },

        {
            field: "discount",
            headerName: "Discount",
            type: "number",
            reportType: "currency",
            flex: 1
        },

        {
            field: "tax",
            headerName: "Tax",
            type: "number",
            reportType: "currency",
            flex: 1
        },

        {
            field: "amount",
            headerName: "Amount",
            type: "number",
            reportType: "currency",
            flex: 1.2
        },

        {
            field: "paymentType",
            headerName: "Payment",
            flex: 1
        }
    ],
    itemSalesReport: [
        { field: "productName", headerName: "Product", flex: 1 },
        { field: "quantitySold", headerName: "Quantity Sold", flex: 1, type: "number" },
        { field: "salesAmount", headerName: "Sale Amount", flex: 1, reportType: "currency" },
    ],
    categorySalesReport: [
        { field: "categoryName", headerName: "Product", flex: 1 },
        { field: "quantitySold", headerName: "Quantity Sold", flex: 1, type: "number" },
        { field: "totalSales", headerName: "Total Sale Amount", flex: 1, reportType: "currency" },
    ],
    purchasePaymentReport: [
        { field: "paymentMode", headerName: "PaymentMode", flex: 1 },
        { field: "totalAmount", headerName: "Total Amount", flex: 1, type: "number" },
        { field: "transactionCount", headerName: "Total Transaction Count", flex: 1,reportType: "currency" },
    ],
    PurchaseGstReport: [
        { field: "taxRate", headerName: "Tax Rate", flex: 1 },
        { field: "taxableAmount", headerName: "Taxable Amount", flex: 1, type: "number" },
        { field: "gstAmount", headerName: "Total Gst Amount", flex: 1,reportType: "currency" },
    ],
    purchaseReport: [
        {
            field: "invoiceNo",
            headerName: "Invoice #",
            flex: 1
        },

        {
            field: "date",
            headerName: "Date",
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null,
            flex: 1
        },

        {
            field: "supplier",
            headerName: "supplier",
            flex: 1.5
        },

        {
            field: "total",
            headerName: "total",
            flex: 2
        },
        {
            field: "product",
            headerName: "product",
            flex: 2
        },

        {
            field: "quantity",
            headerName: "Qty",
            type: "number",
            flex: 0.7
        },

        {
            field: "costPrice",
            headerName: "costPrice",
            type: "number",
            reportType: "currency",
            flex: 1
        },

        

        {
            field: "tax",
            headerName: "Tax",
            type: "number",
            reportType: "currency",
            flex: 1
        },

        {
            field: "amount",
            headerName: "Amount",
            type: "number",
            reportType: "currency",
            flex: 1.2
        },

        
    ],

    CategoryExpenseReport: [
        { field: "expenseCategory", headerName: "Expense Category", flex: 1 },
        { field: "totalAmount", headerName: "Total Amount", flex: 1, type: "number" },
        
    ],
    ProfitExpenseReport: [
        { field: "totalSales", headerName: "Total Sales", flex: 1 },
        { field: "totalPurchase", headerName: "Total Purchase", flex: 1, type: "number" },
        { field: "totalExpense", headerName: "Total Expense", flex: 1, type: "number" },
        { field: "profit", headerName: "Total Profit", flex: 1, type: "number" },
        
    ],
};